<template>

    <MenuSiModuleMain/>
<!--    <HeadingApplications/>-->

    <div class="px-6 surface-overlay relative">
        <div class="grid">
            <div class="col-12 md:col-12">
                <div class="card p-fluid">

                    <div class="grid -mt-3 -ml-3 -mr-3">

                        <div class="col-12 md:col-6 lg:col-4">
                            <div class="p-2">
                                <div class="shadow-2 p-4 surface-card border-round">
                                    <div class="relative mb-3">
                                        <img src="images/appstore/application11/application11.logo.jpg" class="w-full"/>
                                    </div>
                                    <div class="flex justify-content-between align-items-center mb-3">
                                        <span class="text-900 font-medium text-xl">Simply Investing Podcast</span>
                                        <span>
                            <i class="pi pi-star-fill text-yellow-500 mr-1"></i>
                            <span class="font-medium">5.0</span>
                        </span>
                                    </div>
                                    <p><span class="text-900">Podcast</span></p>
                                    <p class="mt-0 mb-3 text-600 line-height-3">
                                        A podcast by Kanwal Sarai, a dividend investor and entrepreneur, talking about
                                        dividend investing,
                                        and helping you save time, earn more and reduce your risk by investing
                                        confidently.
                                    </p>

                                    <Button label="Access" class="w-full" @click="processAccessApplication12"></Button>

                                </div>
                            </div>
                        </div>

                        <div class="col-12 md:col-6 lg:col-4">
                            <div class="p-2">
                                <div class="shadow-2 p-4 surface-card border-round">
                                    <div class="relative mb-3">
                                        <img src="images/appstore/logo.si.course.jpeg" class="w-full"/>
                                    </div>
                                    <div class="flex justify-content-between align-items-center mb-3">
                                        <span class="text-900 font-medium text-xl">Simply Investing</span>
                                        <span>
                            <i class="pi pi-star-fill text-yellow-500 mr-1"></i>
                            <span class="font-medium">5.0</span>
                        </span>
                                    </div>
                                    <p><span class="text-900">Course</span></p>
                                    <p class="mt-0 mb-3 text-600 line-height-3">
                                        The Simply Investing Course is the easiest way to learn how to find quality
                                        dividend paying stocks when
                                        they are priced low. Safely build your own resilient portfolio that generates
                                        growing passive income
                                        each year. You can apply these strategies to any stock market in the world.
                                    </p>

                                    <Button v-show="this.userConfiguration.enableAppstoreApp9 === 'Y'" label="Access"
                                            class="w-full" @click="processAccessApplication9"></Button>
                                    <Button v-show="this.userConfiguration.enableAppstoreApp9 === 'N'" label="£49"
                                            class="w-full" @click="processPurchaseApplication9"></Button>

                                </div>
                            </div>
                        </div>

                        <div class="col-12 md:col-6 lg:col-4">
                            <div class="p-2">
                                <div class="shadow-2 p-4 surface-card border-round">
                                    <div class="relative mb-3">
                                        <img src="images/appstore/logo.mh.png" class="w-full"/>
                                    </div>
                                    <div class="flex justify-content-between align-items-center mb-3">
                                        <span class="text-900 font-medium text-xl">Moulding Health</span>
                                        <span>
                            <i class="pi pi-star-fill text-yellow-500 mr-1"></i>
                            <span class="font-medium">5.0</span>
                        </span>
                                    </div>
                                    <p><span class="text-900">Podcast</span></p>
                                    <p class="mt-0 mb-3 text-600 line-height-3">
                                        In this podcast, we leverage the wisdom and experience of healthcare
                                        practitioners to set us on a path of self-discovery and healing.
                                    </p>

                                    <Button label="Access" class="w-full" @click="processAccessApplication1"></Button>

                                </div>
                            </div>
                        </div>

                        <div class="col-12 md:col-6 lg:col-4">
                            <div class="p-2">
                                <div class="shadow-2 p-4 surface-card border-round">
                                    <div class="relative mb-3">
                                        <img src="images/appstore/logo.mpp.png" class="w-full"/>
                                    </div>
                                    <div class="flex justify-content-between align-items-center mb-3">
                                        <span class="text-900 font-medium text-xl">Moulding Private Practice</span>
                                        <span>
                            <i class="pi pi-star-fill text-yellow-500 mr-1"></i>
                            <span class="font-medium">5.0</span>
                        </span>
                                    </div>
                                    <p><span class="text-900">Podcast</span></p>
                                    <p class="mt-0 mb-3 text-600 line-height-3">
                                        In this podcast, we showcase the incredible stories of healthcare practitioners,
                                        and
                                        understand their journey to becoming a practitioner and the challenges of
                                        private
                                        practice.
                                    </p>

                                    <Button label="Access" class="w-full" @click="processAccessApplication2"></Button>

                                </div>
                            </div>
                        </div>

                        <div class="col-12 md:col-6 lg:col-4">
                            <div class="p-2">
                                <div class="shadow-2 p-4 surface-card border-round">
                                    <div class="relative mb-3">
                                        <img src="images/appstore/logo.ml.png" class="w-full"/>
                                    </div>
                                    <div class="flex justify-content-between align-items-center mb-3">
                                        <span class="text-900 font-medium text-xl">Moulding Lives</span>
                                        <span>
                            <i class="pi pi-star-fill text-yellow-500 mr-1"></i>
                            <span class="font-medium">5.0</span>
                        </span>
                                    </div>
                                    <p><span class="text-900">Podcast</span></p>
                                    <p class="mt-0 mb-3 text-600 line-height-3">
                                        In this podcast, we showcase the amazing stories of people that are committed to
                                        building a
                                        better life for themselves and those around them, and in so doing build
                                        generational
                                        wealth.
                                    </p>

                                    <Button label="Access" class="w-full" @click="processAccessApplication3"></Button>

                                </div>
                            </div>
                        </div>

                        <div class="col-12 md:col-6 lg:col-4">
                            <div class="p-2">
                                <div class="shadow-2 p-4 surface-card border-round">
                                    <div class="relative mb-3">
                                        <img src="images/appstore/logo.adhd.png" class="w-full"/>
                                    </div>
                                    <div class="flex justify-content-between align-items-center mb-3">
                                        <span class="text-900 font-medium text-xl">ADHD 101</span>
                                        <span>
                            <i class="pi pi-star-fill text-yellow-500 mr-1"></i>
                            <span class="font-medium">5.0</span>
                        </span>
                                    </div>
                                    <p><span class="text-900">Online Course</span></p>
                                    <p class="mt-0 mb-3 text-600 line-height-3">
                                        Online course presented with insights on ADHD from a Speech Therapist, an
                                        Educational
                                        Psychologist,
                                        an Educator and an Occupational Therapist.
                                    </p>

                                    <Button v-show="this.userConfiguration.enableAppstoreApp4 === 'Y'" label="Access"
                                            class="w-full" @click="processAccessApplication4"></Button>
                                    <Button v-show="this.userConfiguration.enableAppstoreApp4 === 'N'" label="£49"
                                            class="w-full" @click="processPurchaseApplication4"></Button>
                                </div>
                            </div>
                        </div>


                        <div class="col-12 md:col-6 lg:col-4">
                            <div class="p-2">
                                <div class="shadow-2 p-4 surface-card border-round">
                                    <div class="relative mb-3">
                                        <img src="images/appstore/logo.privatepractice.png" class="w-full"/>
                                    </div>
                                    <div class="flex justify-content-between align-items-center mb-3">
                                        <span class="text-900 font-medium text-xl">Private Practice 101</span>
                                        <span>
                            <i class="pi pi-star-fill text-yellow-500 mr-1"></i>
                            <span class="font-medium">5.0</span>
                        </span>
                                    </div>
                                    <p><span class="text-900">Application</span></p>
                                    <p class="mt-0 mb-3 text-600 line-height-3">
                                        If you're looking to start or build your private practice, our Private Practice
                                        Education Software
                                        is your step-by-step guide to highlighting your path to success.
                                    </p>

                                    <Button v-show="this.userConfiguration.enableAppstoreApp5 === 'Y'" label="Access"
                                            class="w-full" @click="processAccessApplication5"></Button>
                                    <Button v-show="this.userConfiguration.enableAppstoreApp5 === 'N'" label="£19"
                                            class="w-full" @click="processPurchaseApplication5"></Button>

                                </div>
                            </div>
                        </div>

                        <div class="col-12 md:col-6 lg:col-4">
                            <div class="p-2">
                                <div class="shadow-2 p-4 surface-card border-round">
                                    <div class="relative mb-3">
                                        <img src="images/appstore/logo.isovault.png" class="w-full"/>
                                    </div>
                                    <div class="flex justify-content-between align-items-center mb-3">
                                        <span class="text-900 font-medium text-xl">IsoVault</span>
                                        <span>
                            <i class="pi pi-star-fill text-yellow-500 mr-1"></i>
                            <span class="font-medium">5.0</span>
                        </span>
                                    </div>
                                    <p><span class="text-900">Application</span></p>
                                    <p class="mt-0 mb-3 text-600 line-height-3">
                                        Security is not optional. It is a necessary attribute of every successful and
                                        ethical
                                        business and healthcare practitioner. This Password Management Software is
                                        invaluable.
                                    </p>

                                    <Button v-show="this.userConfiguration.enableAppstoreApp6 === 'Y'" label="Access"
                                            class="w-full" @click="processAccessApplication6"></Button>
                                    <Button v-show="this.userConfiguration.enableAppstoreApp6 === 'N'" label="£5 pm"
                                            class="w-full" @click="processPurchaseApplication6"></Button>

                                </div>
                            </div>
                        </div>

                        <div class="col-12 md:col-6 lg:col-4">
                            <div class="p-2">
                                <div class="shadow-2 p-4 surface-card border-round">
                                    <div class="relative mb-3">
                                        <img src="images/appstore/logo.isowishes.png" class="w-full"/>
                                    </div>
                                    <div class="flex justify-content-between align-items-center mb-3">
                                        <span class="text-900 font-medium text-xl">IsoWishes</span>
                                        <span>
                            <i class="pi pi-star-fill text-yellow-500 mr-1"></i>
                            <span class="font-medium">5.0</span>
                        </span>
                                    </div>
                                    <p><span class="text-900">Application</span></p>
                                    <p class="mt-0 mb-3 text-600 line-height-3">
                                        Financial and Estate Management Software designed to help individuals, families,
                                        and
                                        businesses manage
                                        their financial and estate-related matters efficiently.
                                    </p>

                                    <Button v-show="this.userConfiguration.enableAppstoreApp7 === 'Y'" label="Access"
                                            class="w-full" @click="processAccessApplication7"></Button>
                                    <Button v-show="this.userConfiguration.enableAppstoreApp7 === 'N'" label="£5 pm"
                                            class="w-full" @click="processPurchaseApplication7"></Button>

                                </div>
                            </div>
                        </div>

                        <div class="col-12 md:col-6 lg:col-4">
                            <div class="p-2">
                                <div class="shadow-2 p-4 surface-card border-round">
                                    <div class="relative mb-3">
                                        <img src="images/appstore/logo.isorates.png" class="w-full"/>
                                    </div>
                                    <div class="flex justify-content-between align-items-center mb-3">
                                        <span class="text-900 font-medium text-xl">IsoRates</span>
                                        <span>
                            <i class="pi pi-star-fill text-yellow-500 mr-1"></i>
                            <span class="font-medium">5.0</span>
                        </span>
                                    </div>
                                    <p><span class="text-900">Application</span></p>
                                    <p class="mt-0 mb-3 text-600 line-height-3">
                                        IsoRates provides healthcare insurance and medical aid rates in South Africa and
                                        the UK,
                                        along with NAPPI Codes, for
                                        healthcare practitioners in private practice.
                                    </p>

                                    <Button label="Access" class="w-full" @click="processAccessApplication10"></Button>

                                </div>
                            </div>
                        </div>

                    </div>

                </div>
            </div>
        </div>
    </div>

    <IsoEvolveFooter/>

</template>

<script>
import IsoEvolveFooter from "@/components/heading/authentication/IsoEvolveFooter.vue";
import {useUserStore} from "@/stores/UserStore";
import UserService from "@/service/UserService";
import MenuSiModuleMain from "@/components/menu/simodule/MenuSiModuleMain.vue";

export default {
    components: {
        MenuSiModuleMain,
        IsoEvolveFooter
    },
    setup() {
        const userStore = useUserStore()

        return {
            userStore
        }
    },
    async mounted() {
        try {
            // Attempt to get user data
            const userData = await UserService.getUser(this.userStore.user.id);
            this.profile = userData.data;
            console.log("[Applications][mounted] Data = ", userData);
            console.log("[Applications][mounted] this.profile = ", this.profile);
        } catch (e) {
            console.error("[Applications][mounted] Error fetching user data = ", e);
            this.userStore.clearUser();
            this.$router.push('login');
            return; // Exit early if getUser fails
        }

        try {
            const [userConfigData] = await Promise.all([
                UserService.getUserConfig(this.userStore.user.id)
            ]);

            this.userConfiguration = userConfigData.data;
            console.log("[Applications][mounted] userConfigData.data = ", userConfigData.data);
        } catch (e) {
            console.error("[Applications][mounted] Could not find user config for user = ", this.userStore.user.id);
        }

        try {
            const [userConfigData] = await Promise.all([
                UserService.getUserConfig(this.userStore.user.id)
            ]);

            this.userConfiguration = userConfigData.data;
            console.log("[Applications][mounted] userConfigData.data = ", userConfigData.data);
        } catch (e) {
            console.error("[Applications][mounted] Could not find user config for user = ", this.userStore.user.id);
            this.userConfiguration = {
                enableAppstoreApp1: 'N',
                enableAppstoreApp2: 'N',
                enableAppstoreApp3: 'N',
                enableAppstoreApp4: 'N',
                enableAppstoreApp5: 'N',
                enableAppstoreApp6: 'N',
                enableAppstoreApp7: 'N',
                enableAppstoreApp8: 'N',
                enableAppstoreApp9: 'N',
                enableAppstoreApp10: 'N'
            };
        }
    },
    data() {

        return {
            profile: {},
            userConfiguration: {},
        }
    },
    methods: {
        processAccessApplication1() {
            console.log("[Applications][processAccessApplication1] Beginning.");

            window.location.href = "/#/appStoreUserApplication1";
        },
        processAccessApplication2() {
            console.log("[Applications][processAccessApplication2] Beginning.");

            window.location.href = "/#/appStoreUserApplication2";
        },
        processAccessApplication3() {
            console.log("[Applications][processAccessApplication3] Beginning.");

            window.location.href = "/#/appStoreUserApplication3";
        },
        processAccessApplication4() {
            console.log("[Applications][processAccessApplication4] Beginning.");

            window.location.href = "/#/appStoreUserApplication1";
        },
        processAccessApplication5() {
            console.log("[Applications][processAccessApplication5] Beginning.");

            window.location.href = "/#/appStoreUserApplication1";
        },
        processAccessApplication6() {
            console.log("[Applications][processAccessApplication6] Beginning.");

            window.location.href = "/#/appStoreUserApplication1";
        },
        processAccessApplication7() {
            console.log("[Applications][processAccessApplication7] Beginning.");

            window.location.href = "/#/appStoreUserApplication1";
        },
        processAccessApplication8() {
            console.log("[Applications][processAccessApplication8] Beginning.");

            window.location.href = "/#/appStoreUserApplication8";
        },
        processAccessApplication9() {
            console.log("[Applications][processAccessApplication9] Beginning.");

            window.location.href = "/#/appStoreUserApplication9";
        },
        processAccessApplication10() {
            console.log("[Applications][processAccessApplication10] Beginning.");

            window.location.href = "/#/appStoreUserApplication10";
        },
        processAccessApplication11() {
            console.log("[Applications][processAccessApplication11] Beginning.");

            window.location.href = "/#/appStoreUserApplication11";
        },
        processAccessApplication12() {
            console.log("[Applications][processAccessApplication12] Beginning.");

            window.location.href = "/#/appStoreUserApplication12";
        },
        processPurchaseApplication4() {
            console.log("[Applications][processPurchaseApplication4] Beginning.");

            window.open(
                'https://buy.stripe.com/5kAg0I8Zr0vm5kk9BM',
                '_blank' // <- This is what makes it open in a new window.
            );
        },
        processPurchaseApplication5() {
            console.log("[Applications][processPurchaseApplication5] Beginning.");

            window.open(
                'https://buy.stripe.com/5kAg0I8Zr0vm5kk9BM',
                '_blank' // <- This is what makes it open in a new window.
            );
        },
        processPurchaseApplication6() {
            console.log("[Applications][processPurchaseApplication6] Beginning.");

            window.open(
                'https://buy.stripe.com/5kAg0I8Zr0vm5kk9BM',
                '_blank' // <- This is what makes it open in a new window.
            );
        },
        processPurchaseApplication7() {
            console.log("[Applications][processPurchaseApplication7] Beginning.");

            window.open(
                'https://buy.stripe.com/5kAg0I8Zr0vm5kk9BM',
                '_blank' // <- This is what makes it open in a new window.
            );
        },
        processPurchaseApplication8() {
            console.log("[Applications][processPurchaseApplication8] Beginning.");

            window.open(
                'https://buy.stripe.com/5kAg0I8Zr0vm5kk9BM',
                '_blank' // <- This is what makes it open in a new window.
            );
        },
        processPurchaseApplication9() {
            console.log("[Applications][processPurchaseApplication9] Beginning.");

            window.open(
                'https://buy.stripe.com/5kAg0I8Zr0vm5kk9BM',
                '_blank' // <- This is what makes it open in a new window.
            );
        },
    }
};
</script>

<style scoped>
a {
    text-decoration: none;
}
</style>
